import { RULES } from "@wallyo/contracts/rules";

import type { RuleNames } from "./feature-names";

/** The English names, taken straight from the rule catalog (#185). */
export const rulesEn: RuleNames = {
  rules: Object.fromEntries(RULES.map((rule) => [rule.ruleId, rule.name])) as RuleNames["rules"],
  categories: {
    payments: "Payments",
    support: "Cases",
    safety: "Trust & safety",
    onboarding: "Verification",
    jobs: "Job requests",
    access: "Access",
  },
};
